import React, {  useState } from 'react';
import { numberWithCommas } from '../../../../../utils/functions';
import SectionCard from './components/SectionCard';
import OverviewStatisticsContent from './components/OverviewStatisticsContent';
// import RewardCard from './components/RewardCard';

import './SecondaryCreationSummary.css';

const SecondaryCreationSummary = ({
  quest, questLeaderboard,
}) => {
  console.log("quest", quest)
  console.log("questLeaderboard", questLeaderboard)
  const [selectedPlatform] = useState('youtube');
  const { secondaryStats, splitTiers } = quest
  // 页面加载时自动调用

  const handlePlatformClick = async (platform) => {
    // const { token } = auth;
    // const { questId } = router.params;
    // if (questId) {
    //   getCCQuestTiered(questId, token);
    // }
  };
  //  

  // const handleRefresh = async () => {
  //   try {
  //     const today = new Date();
  //     const dateString = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
  //     const response = await fetch(`/api/v1/admin/debug/run-daily-summary`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         date: dateString,
  //         questId: quest.id
  //       })

  //     });

  //     if (response.ok) {
  //       alert('数据刷新成功！');
  //       // 刷新后重新获取当前平台数据
  //       await handlePlatformClick(selectedPlatform);
  //     } else {
  //       throw new Error('刷新失败');
  //     }
  //   } catch (error) {
  //     console.error('刷新数据失败:', error);
  //     alert('刷新数据失败，请稍后重试');
  //   } finally {
  //   }
  // };

  // 平台按钮数据
  const platforms = [
    {
      name: 'YouTube',
      icon: <svg className="platform-icon" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"></path></svg>
    },
  ];

  // 统计数据
  const overviewStats = [
    {
      label: 'Total Views',
      value: numberWithCommas(secondaryStats?.totalViews || 0)
    },
    {
      label: 'Total Videos',
      value: numberWithCommas(secondaryStats?.totalVideos || 0)
    },
    {
      label: 'Total Likes',
      value: numberWithCommas(secondaryStats?.totalLikes || 0)
    },
    {
      label: 'Total Comments',
      value: numberWithCommas(secondaryStats?.totalComments || 0)
    },
    {
      label: 'Total Shares',
      value: numberWithCommas(secondaryStats?.totalShares || 0)
    },
    {
      label: 'Avg Watch Duration',
      value: `${numberWithCommas(secondaryStats?.avgCompletePercentage || 0)}%`
    }
  ];

  // console.log("quest",quest)
  // 奖励分层数据
  // const rewardTiers = platformData?.rewardTiers || [];
  // 排名数据 - 使用API返回的rankings
  // const rankTiers = platformData?.rankings || [];

  return (
    <section className="Summary_auto_second_content">
      {/* 平台按钮区 */}
      <div className="Summary_auto_second_buttons summary-buttons">
        {platforms.map((p) => (
          <button
            key={p.name}
            className={`platform-btn ${selectedPlatform === p.name.toLowerCase() ? 'active' : ''}`}
            data-platform={p.name.toLowerCase()}
            onClick={() => handlePlatformClick(p.name.toLowerCase())}
          >
            {p.icon} {p.name}
          </button>
        ))}
        {/* <button
          className={`platform-btn right-button`}
          onClick={handleRefresh}
        >
          刷新汇总
        </button> */}
      </div>
      {/* 统计数据区 */}
      <SectionCard title="Overview Statistics">
        <OverviewStatisticsContent overviewStats={overviewStats} />
      </SectionCard>

      {/* 奖励分层区 */}
      <SectionCard title="Reward Tiers">
        <div>
          {splitTiers.length > 0 ? splitTiers.map((tier, idx) => (
            <div className="Summary_auto_second_split_item" key={idx}>
              <div className="Summary_auto_second_split_item_left">
                <div className="Summary_auto_second_split_item_left_level">
                  Tier {idx + 1}
                </div>
                <div className="Summary_auto_second_split_item_left_content">
                  <div className="Summary_auto_second_split_item_left_content_days">
                    minimum {tier.totalUploadDays} days of uploads
                  </div>
                  <div className="Summary_auto_second_split_item_left_content_hours">
                    minimum {tier.validUploadCount} valid posts
                  </div>
                  <div className="Summary_auto_second_split_item_left_content_hours">
                    minimum {tier.totalViews} total views
                  </div>

                </div>
              </div>
              <div className="Summary_auto_second_split_item_middle">
                <div className="Summary_auto_second_split_item_middle_title">
                  Number of Qualifiers
                </div>
                <div className="Summary_auto_second_split_item_middle_content">
                  {tier.qualifiedUserCount ?? 0}
                </div>
              </div>
              <div className="Summary_auto_second_split_item_right">
                <div className="Summary_auto_second_split_item_right_prize">
                  Prize Pool: ${tier.prizePool}
                </div>
                <div className="Summary_auto_second_split_item_right_maxRevenue">
                  Max Per Person: ${tier.maxRevenue}
                </div>
              </div>
            </div>
          )) : <div className="no-data-message">No reward tiers data</div>}
        </div>
      </SectionCard>

      <SectionCard title="Ranking"
        rightHeaderContent={(
          <div className='custom-content'>
            <div className='custom-item'>
              <div>Total Prize Pool</div> <div className="prize-pool-value">{"$" + (quest.totalLeaderBoardPrize || 0)}</div>
            </div>
            <div className='custom-item'>
              <div>Distributed </div>
              <div className="prize-pool-value">{"$" + quest.distributedLeaderBoardPrize || 0}</div>
            </div>
          </div>
        )}>
        <div className="rank_table">
            <table className="rank_table_content">
              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Noiz ID</th>
                  <th>YouTube ID</th>
                  <th>Total Views</th>
                  <th>Total Likes</th>
                  <th>Total Comments</th>
                  <th>Total Shares</th>
                  <th>Total UploadDays</th>
                  <th>Post Videos</th>
                  <th>Avg Watch Duration</th>
                  <th>Overall Score</th>
                  <th>Prize Amount</th>
                </tr>
              </thead>
              <tbody>
                {questLeaderboard?.length > 0 ?questLeaderboard.map((rankEntry, index) => (
                  <tr key={index}>
                    <td>{rankEntry.rank ?? "-"}</td>
                    <td>{rankEntry.user.username}</td>
                    <td>
                      <a
                        href={`https://www.youtube.com/channel/${rankEntry?.user.connectedAccounts.youtube.id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#3a74e0', textDecoration: 'underline', cursor: 'pointer', fontWeight: 'bold' }}
                      >
                        {rankEntry.user.connectedAccounts.youtube.username}
                      </a>
                    </td>
                    <td className='blue-9'>{rankEntry.totalViews ?? "-"}</td>
                    <td className='blue-9'>{rankEntry.totalLikes ?? "-"}</td>
                    <td className='blue-9'>{rankEntry.totalComments ?? "-"}</td>
                    <td className='blue-9'>{rankEntry.totalShares ?? "-"}</td>
                    <td className='blue-9'>{rankEntry.totalUploadDays ?? "-"}</td>
                    <td className='blue-9'>{rankEntry.validVideoCount ?? "-"}</td>
                    <td className='blue-9'>{`${(rankEntry.avgCompletePercentage || 0).toFixed(2)}%`}</td>
                    <td className='blue-9'>{rankEntry.overallScore ?? "-"}</td>
                    <td className='blue-9'>{`$${rankEntry.rankPrize||0}`}</td>
                  </tr>
                )): (
                  <div className="no-ranking-data">No ranking data</div>
                )}
              </tbody>
            </table>
        
        </div>
      </SectionCard>
    </section>
  );
};

export default SecondaryCreationSummary; 